import React from 'react';
import styles from './Criteria.module.scss';
import ActiveSwitch from '../../../../../shared/ui/ActiveSwitch/ActiveSwitch';
import FilterDropdownField from '../../../../../shared/ui/FilterDropdownField/FilterDropdownField';

const Criteria = ({ activeConfig, gridConfigs }) => {
  return (
    <div>
      <ActiveSwitch
        value={activeConfig.value}
        onChange={activeConfig.onChange}
      />
      <div className={styles.content}>
        {gridConfigs?.map((config, index) => (
          <FilterDropdownField
            key={index}
            config={config}
          />
        ))}
      </div>
    </div>
  );
};

export default Criteria;
